import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // *** Events

  handleChange(e) {
    window.location.href = this.replaceUrlParam(
      window.location.href,
      'pilot_prompt_id',
      e.target.value
    )
  }

  // *** Helpers

  replaceUrlParam(url, paramName, paramValue) {
    const urlObject = new URL(url)
    const params = new URLSearchParams(urlObject.search)

    params.set(paramName, paramValue)
    urlObject.search = params.toString()

    return urlObject.href
  }
}
